import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';

interface InventoryListData {
  /* TODO: Phase B */
}

/**
 * 재고 목록 — placeholder.
 *
 * Phase B 구현 예정:
 *   - inventory_unit 테이블 데이터 그리드 (조건/상태/창고 필터)
 *   - [+ 신규 입고 등록] 버튼 → /inventory/new
 *   - 행 클릭 → /inventory/:id 상세
 *   - 글로벌 검색에서 보유 재고로 점프되는 경로
 */
export class InventoryListView extends SolaView<InventoryListData> {
  constructor() {
    super();
    this.data = {};
  }

  override getTitle(): string {
    return '재고 — HCLTech 어드민';
  }

  render(): HTMLElement {
    return htmlSolaWithInstance(this)`
      <div class="page page-inventory">
        <header class="page-header">
          <h1>📦 재고</h1>
        </header>
        <section class="page-body">
          <div class="placeholder-card">
            <h2>곧 구현 예정 (Phase B)</h2>
            <ul>
              <li>보유 inventory_unit 목록 (필터·정렬·페이지)</li>
              <li>신규 입고 등록 폼 (벌크 입력 지원)</li>
              <li>unit 상세 페이지</li>
              <li>SKU 별 집계 보기 (v_inventory_summary)</li>
            </ul>
          </div>
        </section>
      </div>
    `;
  }
}
